



















































import DocumentLink from '@/components/DocumentLink'
import prismicDOM from 'prismic-dom'

export default {
    name: 'Navigation'

    components:
        DocumentLink: DocumentLink

    props: ['id']

    data: ->
        documentId: '',
        fields: @defaultFields()

    methods:
        defaultFields: ->
            items: []

        isActiveLink: (link) ->
            if link and link.uid
                url = prismicDOM.Link.url link, @$prismic.linkResolver
            url is @$route.path

        isMenu: (item) -> item.slice_type is 'menu'

        setContent: (document) ->
            @documentId = document.id
            fields = items: document.data.body
            $.extend @fields, fields

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]

    updated: ->
        $(@$el).find('.uk-navbar-dropdown-nav li:not(.uk-active)').parents('.uk-navbar-nav li').removeClass 'uk-active'
        $(@$el).find('.uk-navbar-dropdown-nav li.uk-active').parents('.uk-navbar-nav li').addClass 'uk-active'

    created: ->
        @getContent @id

}
